import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectCurrentId } from '@gandi/redux-sharing';
import { useNotifications } from '../../../hooks/notifications';
import { resource as meansResource, selectContextualMeans } from '../../../modules/means';
const makeLabel = (context, sharingId) => `${context}.${sharingId}`;
function usePaymentMeans(fetchParams, exclude, include) {
  const dispatch = useDispatch();
  const {
    notifyMaybeApiError
  } = useNotifications();
  const sharingId = useSelector(selectCurrentId);
  const context = fetchParams.context || 'pay';
  const label = makeLabel(context, sharingId);
  const means = useSelector(state => selectContextualMeans(state, {
    label,
    exclude,
    include
  }));
  const isFetching = useSelector(state => meansResource.selectIsFetching(state, {
    label
  }));
  const isLoaded = useSelector(state => meansResource.selectIsLoaded(state, {
    label
  }));
  const isToRefetch = useSelector(state => meansResource.selectIsToRefetch(state, {
    label
  }));
  const isFailure = useSelector(state => meansResource.selectIsFailure(state, {
    label
  }));
  const shouldFetch = useSelector(state => meansResource.selectShouldFetch(state, {
    label
  }));
  React.useEffect(() => {
    if (shouldFetch) {
      try {
        dispatch(meansResource.fetch('/money/means', {
          label,
          params: {
            context,
            currency: fetchParams.currency,
            sharing_id: sharingId,
            allow_empty_prepaid: fetchParams.allowEmptyPrepaid
          },
          on200: response => response,
          not200: response => Promise.reject(response)
        }));
      } catch (e) {
        dispatch(notifyMaybeApiError(e));
      }
    }
  }, [dispatch, shouldFetch, context, label, fetchParams, sharingId, notifyMaybeApiError]);
  return {
    means,
    isFetching,
    isToRefetch,
    shouldFetch,
    isLoaded,
    isFailure
  };
}
export function useCuratedPaymentMeans(fetchParams) {
  const {
    means: allMeans,
    ...resourceInfo
  } = usePaymentMeans(fetchParams);
  const adyenDropinMean = Array.isArray(allMeans) ? allMeans.find(({
    key
  }) => key === 'dropin') : undefined;
  const means = Array.isArray(allMeans) ? allMeans.filter(({
    key
  }) => key !== 'dropin') : undefined;
  const emptyMeans = allMeans?.length === 0;
  return {
    means,
    emptyMeans,
    ...resourceInfo,
    adyenDropinMean
  };
}